import { forwardRef, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../utils/cn.js';

type Tone = 'default' | 'accent' | 'success' | 'warning' | 'danger' | 'info';

export interface KpiCardProps extends HTMLAttributes<HTMLDivElement> {
  label: string;
  value: ReactNode;
  meta?: ReactNode;
  tone?: Tone;
  /** Optional slot for a sparkline / mini chart under the value. */
  chart?: ReactNode;
}

/**
 * Kollez KPI card. Rule from the design system: **tone is on the border, never on the value**.
 */
export const KpiCard = forwardRef<HTMLDivElement, KpiCardProps>(function KpiCard(
  { label, value, meta, tone = 'default', chart, className, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn('kpi', tone !== 'default' && `kpi-tone-${tone}`, className)}
      data-tone={tone}
      {...rest}
    >
      <div className="kpi-label eyebrow">{label}</div>
      <div className="kpi-value">{value}</div>
      {chart ? <div className="kpi-chart">{chart}</div> : null}
      {meta ? <div className="kpi-meta">{meta}</div> : null}
    </div>
  );
});
